import $ from 'jquery';

const popup = '.js-videocast-podcast-popup';
const popupDetailsContainer = '.videocast-podcast__item-popup-container';
const item = '.js-videocast-podcast__item';
const spacer = '.js-videocast-podcast-spacer';
const closeBtn = '.js-videocast-podcast__close-btn';

export const  init = () => {
	itemClickHandler();
	closeBtnHandler();
};

const itemClickHandler = () => {
	$(document).on('click', item, e => {
		
		const $this = $(e.target).parent();
		const $popup = $this.find(popup);
		
		const $container = $this.find(popupDetailsContainer);
		const $spacer = $this.find(spacer);

		setHeight($(spacer), 0)

		$(item).removeClass('videocast-podcast__item--active');
		$this.addClass('videocast-podcast__item--active');
		
		setPopUpHeight($container.height() + 40, $popup, $spacer);
		stopSound();
		
	})
}

const stopSound = () => {
	$.each($('audio'), () => {
		$('audio')[0].pause();
		$('audio')[0].currentTime = 0;
	});
	
}

const closeBtnHandler = () => $(closeBtn).on( 'click', ()=> {
	setPopUpHeight(0, $(popup), $(spacer))
	$(popup).removeClass(`videocast-podcast__item-popup--active`);
	stopSound();
} );

const setPopUpHeight = (height,popup,spacer) => {
	setHeight(popup,height);
	setHeight(spacer,height);
}

const setHeight = ($container, height) => {
	$container.css({
		'max-height':`${height}px`,
		'min-height':`${height }px`
	})
}



export const videoCastPodcast = {
	init: $(popup).length> 0 ? init : ()=> null
};